import { Skeleton } from "@/components/ui/skeleton";

export const EventTabSkeleton = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
      {Array.from({ length: 8 }).map((_, i) => (
        <div key={i} className="space-y-4">
          <Skeleton className="aspect-video w-full rounded-lg bg-white/5" />
          <div className="space-y-2 p-2">
            <Skeleton className="h-6 w-full bg-white/5" />
            <Skeleton className="h-4 w-3/4 bg-white/5" />
            <Skeleton className="h-4 w-1/2 bg-white/5" />
          </div>
        </div>
      ))}
    </div>
  );
};